import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import SectionHeading from "@/components/feature/SectionHeading";
import TopicCard from "@/components/feature/TopicCard";
import { topics } from "@/mocks/topics";
import HomeHero from "./components/HomeHero";
import RoundupSpotlight from "./components/RoundupSpotlight";
import RankingBoard from "./components/RankingBoard";
import MomentsWall from "./components/MomentsWall";
import CategoryGrid from "./components/CategoryGrid";
import CollectionStrip from "./components/CollectionStrip";
import HomeVoice from "./components/HomeVoice";
import HomeCta from "./components/HomeCta";

const latest = topics.slice(2, 7);

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title="瓜田黑料官网 | 年度盘点TOP榜，名场面合集全收录"
        description="瓜田黑料专注娱乐话题年度盘点、TOP榜、名场面合集、人物志与经典案例整理。快速浏览今年最值得吃的话题，补课必备目录，一篇看完所有高能名场面。"
        keywords="瓜田黑料,瓜田黑料年度盘点,瓜田黑料TOP榜,瓜田黑料名场面"
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebSite",
              name: "瓜田黑料",
              url: "https://jiemia.cn/",
              description: "娱乐话题年度盘点、TOP榜与名场面合集内容门户",
              inLanguage: "zh-CN",
              potentialAction: {
                "@type": "SearchAction",
                target: "https://jiemia.cn/rankings?q={search_term_string}",
                "query-input": "required name=search_term_string",
              },
            },
            {
              "@type": "Organization",
              name: "瓜田黑料",
              url: "https://jiemia.cn/",
              email: "hello@guatianheiliao.com",
            },
            {
              "@type": "ItemList",
              name: "瓜田黑料年度话题 TOP 榜",
              itemListElement: topics.slice(0, 6).map((topic, index) => ({
                "@type": "ListItem",
                position: index + 1,
                name: topic.title,
                url: `https://jiemia.cn/topic/${topic.slug}`,
              })),
            },
          ],
        }}
      />
      <SiteHeader />

      <main>
        <HomeHero />
        <RoundupSpotlight />
        <RankingBoard />

        <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
          <SectionHeading
            eyebrow="Latest"
            title="最新整理与后续追踪"
            desc="话题有进展时我们会回到原文补充，这里是最新更新的盘点与复盘。"
            actionPath="/rankings"
            actionLabel="查看全部"
          />
          <div className="mt-8 rounded-lg bg-background-100 px-5 md:px-7 py-2">
            {latest.map((topic) => (
              <TopicCard key={topic.slug} topic={topic} variant="horizontal" />
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/rankings"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-compass-3-line" />
              去年度盘点栏目
            </Link>
            <Link
              to="/faq"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-question-line" />
              补课答疑
            </Link>
          </div>
        </section>

        <MomentsWall />
        <CategoryGrid />
        <CollectionStrip />
        <HomeVoice />
        <HomeCta />
      </main>

      <SiteFooter />
      <BackToTop />
    </div>
  );
}